import React from "react";
import {Image} from "semantic-ui-react";
import imageRegistry from "../../constants/imageRegistry";

const ManagementExpectSection = ({header, info, index, icon}) => {
    return (
        <div className="management">
            <div className="management__header">
                <div>
                    <p className="management__header-header">{header}</p>
                    <p className="management__info-label">{info}</p>
                </div>
                <Image className="management__icon" src={icon}/>
            </div>

        </div>
    );
};

export default ManagementExpectSection;
